/**
 * Function for getting alt text without sizes
 * (we contain sizes and alt text in the markdown string)
 */
export const getPureAltText = (altText: string | null): string => (altText || '').replace(/\{[^{}]*\}/, '')
